<template>
  <div>
    <div v-if="!user.grant.statistics_payment">
      <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="@/assets/images/pages/404.png" alt="graphic-404" class="mx-auto mb-4 max-w-full">
            <h1 class="sm:mx-0 mx-4 mb-12 text-3xl d-theme-heading-color">404 - Page introuvable!</h1>
            <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-heading-color">La page que vous demandez est introuvable</p>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="search_box mb-10">
        <p class="w-strong mb-5">{{ title }}</p>
        <div class="search_box_content">
          <vs-input v-model="model.date_debut" class="w-full" type="date" label="Date début"></vs-input>
          <vs-input :min="model.date_debut" v-model="model.date_fin" class="w-full" type="date" label="Date fin"></vs-input>
          <vs-button @click="filterData" class="z-8 mt-5" color="primary" type="filled">Filtrer</vs-button>
          <vs-button @click="exportData" v-if="is_enable" class="z-8 mt-5" color="primary" type="filled">Exporter</vs-button>
          <vs-button v-else disabled class="z-8 mt-5" color="primary" type="filled">Exporter</vs-button>
        </div>
        <div class="mt-5"><h4>Montant total: {{ amount ? parseFormat(amount) : 0 }} Fcfa</h4></div>
      </div>
      <div class="table_box">
        <div class="onglet">
          <div @click="getDataOnglet(key)" :class="key === index ? 'active_onglet' : ''" v-for="(item, key) in onglets" :key="key">{{ item }}</div>
        </div>
        <div>
          <vs-table
            ref="table"
            :max-items="10"
            :data="data"
          >
            <template slot="thead">
              <vs-th>Date d'expiration</vs-th>
              <vs-th>Nom & prénoms</vs-th>
              <vs-th>Montant payé</vs-th>
              <vs-th>Numéro payeur</vs-th>
              <vs-th>Spécialité</vs-th>
              <vs-th>Statut</vs-th>
              <vs-th>Code consultation</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <span class="">{{ parseDate(tr.expiry_at) }} </span>
                </vs-td>

                <vs-td>
                  <span class="">{{ tr.user }} </span>
                </vs-td>
                <vs-td>
                  <span class="">{{ parseFormat(tr.amount) }} </span>
                </vs-td>
                <vs-td>
                  <span class="">{{ tr.phone }} </span>
                </vs-td>
                <vs-td>
                  <span class=""></span>
                </vs-td>

                <vs-td>
                  <vs-chip color="danger">Expiré</vs-chip>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ tr.code }}</p>
                </vs-td>
              </vs-tr>
              </tbody>
            </template>
          </vs-table>
          <vs-pagination v-if="last_page && model.page" :total="last_page" v-model="model.page"></vs-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { _buildQuery, format } from '../../helper/helper'
import moment from 'moment'
const ongletTitle = [
  'Filtrer les statistiques des paiements expirés par période avant validation',
  'Filtrer les statistiques des paiements expirés par période après validation'
]
export default {
  watch: {
   'model.page': function() {
     this.getData();
   }
  },
  data: () => ({
    information:{},
    last_page: 1,
    filterPrompt: false,
    data: [],
    model:{
      page: 1,
      date_debut:'',
      date_fin: '',
      action: 'before'
    },
    onglets:['Avant validation','Après validation'],
    index: 0,
    title: ongletTitle[0],
    user: {},
    amount: 0
  }),
  created(){
    this.user = JSON.parse(localStorage.getItem('user_cnhu'))
  },
  computed:{
    is_enable(){
      return this.data.length > 0
    }
  },
  mounted(){
    if (this.user.grant.statistics_payment){
      let d = new Date()
      this.model.date_debut = moment(d).format('YYYY-MM-DD')
      this.model.date_fin = moment(d).format('YYYY-MM-DD')
      this.getData()
    }
  },
  methods:{
    toggleFilterPrompt(val = false) {
      this.filterPrompt = val;
    },
    parseFormat(amount){
      return format(amount)
    },
    parseDate(date){
      return moment(date).format('DD-MM-YYYY H:mm')
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/statistics/is-expired" +_buildQuery(this.model))
        .then((response) => {
          this.data = response.data.content.data;
          this.last_page = response.data.content.last_page;
          this.amount = response.data.amount
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "page-login"})
          }
        });
    },
    getDataOnglet(key){
      this.index = key
      if (key === 0){
        this.title = ongletTitle[0]
        this.data = []
        this.model.page = 1
        this.model.action = 'before'
        let d = new Date()
        this.model.date_debut = moment(d).format('YYYY-MM-DD')
        this.model.date_fin = moment(d).format('YYYY-MM-DD')
        this.amount = 0
        this.getData()
      }else{
        this.title = ongletTitle[1]
        this.data = []
        this.model.page = 1
        this.model.action = 'after'
        let d = new Date()
        this.model.date_debut = moment(d).format('YYYY-MM-DD')
        this.model.date_fin = moment(d).format('YYYY-MM-DD')
        this.getData()
      }

    },
    filterData(){
      this.model.page = 1
      this.getData()
    },
    exportData(){
      this.$vs.loading()
      this.$http.post('/statistics/is-expired', this.model, {
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = link.href = url
        let name = this.index === 0 ? 'payment_expirer_avant_validation.xlsx' : 'payment_expirer_apres_validation.xlsx'
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
        this.$vs.loading.close()
      }).catch((error) => {
        this.$vs.loading.close()
        if (error.response.status === 401) {
          this.$vs.notify({
            title: 'Erreur',
            text: 'Votre session a expiré',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-check',
            position: 'top-right'
          })
          this.$router.push({name: "page-login"})
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .table_box{
    background: #FFFFFF;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    min-height: 80px;
    padding: 10px;
    width: 100%;
  }
  .onglet{
    display: grid;
    grid-template-columns: 120px 120px;
    grid-gap: 20px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .active_onglet{
    border-bottom: 4px solid #8C8BBF;
    //box-shadow: 0px 0px 6px rgba(115, 103, 240, 0.45277);
  }
  .search_box{
    background: #FFFFFF;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    min-height: 80px;
    padding: 10px;
    width: 100%;
  }
  .search_box_content{
    display: grid;
    grid-template-columns: 300px 300px 110px 110px;
    grid-gap: 10px;
  }
  .z-8{
    height: 40px;
  }
  @media only screen and (max-width: 935px) {
    .search_box_content{
      display: grid !important;
      grid-template-columns: 200px 200px 110px 110px !important;
      grid-gap: 10px !important;
    }
  }
  @media only screen and (max-width: 740px) {
    .search_box_content{
      display: grid !important;
      grid-template-columns: 150px 150px 110px 110px !important;
      grid-gap: 10px !important;
    }
  }
  @media only screen and (max-width: 640px) {
    .search_box_content{
      display: grid !important;
      grid-auto-flow: row;
      grid-template-columns: 1fr !important;
      grid-gap: 10px !important;
    }
  }
  .w-strong{
    font-weight: bold;
  }
</style>
